import { Close } from "@mui/icons-material";
import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { PropsWithChildren } from "react";

type ModalProps = {
  title?: string;
  open: boolean;
  onClose: () => void;
  fullWidth?: boolean;
  fullHeight?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  titleBorder?: boolean;
};

export function TransitionModal({
  title,
  children,
  open,
  onClose,
  fullWidth = true,
  fullHeight = true,
  titleBorder = false,
  maxWidth = 'md',
}: PropsWithChildren<ModalProps>) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      PaperProps={{
        sx: {
          borderRadius: 4,
          position: "relative",
          minHeight: fullHeight ? 0.95 : 'auto',
          maxHeight: 0.95,
        },
      }}
    >
      <DialogTitle
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: title ? "space-between" : "flex-end",
          position: "absolute",
          top: 0,
          zIndex: 110,
          borderBottom: titleBorder ? 1 : 0,
          borderColor: "divider",
        }}
      >
        {title && (
          <Box sx={{ display: "flex", alignItems: "center" }}>{title}</Box>
        )}
        <Button
          color="inherit"
          onClick={onClose}
          sx={{
            minWidth: "unset",
            padding: 0,
            ":hover": { background: "none" },
          }}
        >
          <Close />
        </Button>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: 0,
          display: "flex",
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
